<p-table stripedRows #dtItems
    [value]="items"
    dataKey="id"
    editMode="row"
    [(selection)]="selected"
    [style]="{ width: '100%', 'min-width': '80em' }"
    scrollHeight="flex"
    [scrollable]="true"
    selectionMode="single"
    (onRowSelect)="this.SelectItem.next($event.data)"
>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="numCols" style="text-align: center">
                <div class="tabulator-placeholder">
                    <span> No Data Available </span>
                </div>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="loadingbody">
        <tr>
            <td [attr.colspan]="numCols" style="text-align: center">
                <div>Loading...<i class="fa fa-spinner fa-spin"></i></div>
            </td>
        </tr>
    </ng-template>
    <ng-template #header let-item>
        <tr>
            <!-- Edit -->
            <th class="edit-cell"></th>
            <!-- status-->
            <th class="status-cell">
                <i
                    class="pi pi-exclamation-circle"
                    title="Status"
                ></i>
            </th>
            <!-- Selection -->
            <!-- <th style="width: 3em; text-align: center" >
        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
    </th> -->

            <!-- Invoicepropertyid -->
            <th pSortableColumn="Invoicepropertyid">
                Item
                <p-sortIcon
                    field="Invoicepropertyid"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
                <p-columnFilter field="Invoicepropertyid" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false"
                    [showAddButton]="false" class="ml-auto">
                    <ng-template #filter let-value let-filter="filterCallback">
                        <p-multiSelect
                            defaultLabel="Filter"
                            maxSelectedLabels="1"
                            appendTo="body"
                            [options]="invoiceProperties"
                            [filter]="true"
                            styleClass="w-full" [ngModel]="value" (ngModelChange)="filter($event)"
                        ></p-multiSelect>
                    </ng-template>
                </p-columnFilter>
            </th>
            <!-- Propertylabel -->
            <th pSortableColumn="Propertylabel">
                Label
                <p-sortIcon
                    field="Propertylabel"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
                <p-columnFilter type="text" matchMode="contains" field="Propertylabel" display="menu" class="ml-auto" />
            </th>
            <!-- Propertytext -->
            <th pSortableColumn="Propertytext">
                Value
                <p-sortIcon
                    field="Propertytext"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
                <p-columnFilter type="text" matchMode="contains" field="Propertytext" display="menu" class="ml-auto" />
            </th>
            <!-- delete -->
            <th class="delete-cell"></th>
        </tr>
    </ng-template>
    <ng-template
        #body
        let-item
        let-edit="editing"
        let-ri="rowIndex"
        let-rowData
    >
        <tr
            [pSelectableRow]="item"
            [pEditableRow]="item"
            data-id="row-{{ item.id }}"
            [ngClass]="{
                'ui-editing-row': edit && editing?.id === rowData?.id
            }"
        >
            <!-- Edit -->
            <td class="edit-cell">
                <button
                    *ngIf="item?.id === 'add' && !edit"
                    pButton
                    type="button"
                    icon="pi pi-plus"
                    severity="success"
                    text
                    rounded
                    (click)="addSelectionReplaySubject.next(true)"
                ></button>
                <button
                    *ngIf="
                        !edit &&
                        (!editing?.id || editing?.id === item?.id) &&
                        item.id !== 'add'
                    "
                    pButton
                    type="button"
                    icon="pi pi-pencil"
                    text
                    rounded
                    (click)="onEditItem(item)"
                ></button>
                <button
                    *ngIf="edit"
                    pButton
                    type="button"
                    pSaveEditableRow
                    icon="pi pi-check"
                    severity="success"
                    text
                    rounded
                    (click)="onRowEditSave(item)"
                ></button>
                <button
                    *ngIf="edit"
                    pButton
                    type="button"
                    pCancelEditableRow
                    icon="pi pi-times"
                    severity="danger"
                    text
                    rounded
                    (click)="onRowEditCancel(item)"
                ></button>
            </td>
            <!-- Status-->
            <td class="status-cell">
                <div (click)="onStatusClick(item)" class="status-cell">
                    <ef-status-icon
                        [status]="item?.Status?.StatusCode"
                        [message]="item?.Status?.Message"
                    ></ef-status-icon>
                </div>
            </td>
            <!-- Selection -->
            <!-- <td
                        style="width: 3em; text-align: center"

                    >
                        <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                    </td> -->

            <!-- Invoicepropertyid -->
            <td [attr.title]="
                    (
                        invoiceProperties
                        | itemlookup: 'value':item?.Invoicepropertyid
                    )?.label
                "
            >
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <p-select
                            [options]="invoiceProperties"
                            [filter]="true"
                            appendTo="body"
                            [autoDisplayFirst]="false"
                            placeholder="Type"
                            [(ngModel)]="item.Invoicepropertyid"
                        >
                        </p-select>
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        {{
                            (
                                invoiceProperties
                                | itemlookup: 'value':item?.Invoicepropertyid
                            )?.label
                        }}
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{
                            (
                                invoiceProperties
                                | itemlookup: 'value':item?.Invoicepropertyid
                            )?.label
                        }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Propertylabel -->
            <td  [attr.title]="item.Propertylabel">
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <input pInputText [(ngModel)]="item.Propertylabel" />
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        {{ item.Propertylabel }}
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{ item.Propertylabel }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <!-- Propertytext -->
            <td class="large-cell" [attr.title]="item.Propertytext">
                <p-cellEditor>
                    <ng-template *ngIf="!item.IsReadOnly" pTemplate="input">
                        <input pInputText [(ngModel)]="item.Propertytext" />
                    </ng-template>
                    <ng-template *ngIf="item.IsReadOnly" pTemplate="input">
                        {{ item.Propertytext }}
                    </ng-template>
                    <ng-template pTemplate="output">
                        {{ item.Propertytext }}
                    </ng-template>
                </p-cellEditor>
            </td>
            <td class="delete-cell">
                <button
                    pButton
                    type="button"
                    class="btn btn-link"
                    (click)="DeleteItem.next(item)"
                    icon="pi pi-trash"
                    class="p-button-danger p-button-rounded p-button-text"
                ></button>
            </td>
        </tr>
    </ng-template>
</p-table>
<ef-invoice-selection-add
    [invoiceProperties]="invoiceProperties"
    [item]="editItemSubject.asObservable() | async"
    [addSelection]="addSelectionReplaySubject.asObservable() | async"
    (Cancel)="onCancelSelectionAdd()"
    (Save)="onSaveSelection($event)"
></ef-invoice-selection-add>
